module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/purple.png?da1144df";